module.exports = __webpack_public_path__ + "static/ogunleye-bbc51fee0e203470761b0abb29f189dc.png";